var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtevaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 30.809,
    viewBox: "0 0 88 30.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eteva_Logo",
    transform: "translate(0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2370540536496",
    transform: "translate(-0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M10721.594,5968.642h1.062v-.545h-2.715v.545H10721v2.8h.593Zm6.8-.545h-2.48v3.346h2.5v-.526h-1.917v-.9h1.678v-.526h-1.678v-.87h1.893Zm6.272,2.811-.378-.382a1.309,1.309,0,0,1-.96.435,1.194,1.194,0,0,1,0-2.381,1.331,1.331,0,0,1,.937.416l.378-.435a1.747,1.747,0,0,0-1.31-.521,1.731,1.731,0,0,0-.024,3.461A1.726,1.726,0,0,0,10734.669,5970.908Zm5.44-.875v1.41h.588V5968.1h-.588v1.391h-1.6V5968.1h-.588v3.346h.588v-1.41Z",
    transform: "translate(-10670.818 -5940.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M10729.7,965.61l1.929,3.575,1.974-3.656-2.281-2.923L10720.8,949.13Z",
    transform: "translate(-10671.674 -944.781)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M10861.04,722.3l-12.14-10.471,10.518,13.475,2.281,2.923,1.974-3.656Z",
    transform: "translate(-10799.188 -708.568)",
    fill: "#34cc67",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M10989.207,485.01l2.633,2.271,1.759-3.258.215-.4h0l1.368-2.535,1.17-2.169.327-.605h-2.112a2.933,2.933,0,0,0-2.5,1.4l-.153.284h0l-1.081,2-13.76-7.466,12.139,10.471Z",
    transform: "translate(-10926.768 -472.365)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M9.191,1312.881a6.2,6.2,0,0,1,6.016,4.7H3.175a6.2,6.2,0,0,1,6.016-4.7Zm4.262,10.7a6.2,6.2,0,0,1-10.278-3H18.269a9.2,9.2,0,1,0-1.053,3H13.453Z",
    transform: "translate(0.01 -1303.878)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M6970.192,1312.881a6.2,6.2,0,0,1,6.016,4.7h-12.032a6.2,6.2,0,0,1,6.017-4.7Zm4.262,10.7a6.2,6.2,0,0,1-10.278-3h15.095a9.2,9.2,0,1,0-1.053,3h-3.763Z",
    transform: "translate(-6929.094 -1303.878)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M15206.812,1328.272h-3v-2.4a9.2,9.2,0,1,1,0-13.6v-2.4h3Zm-9.2-15.4a6.2,6.2,0,1,1-6.2,6.2A6.2,6.2,0,0,1,15197.61,1312.871Z",
    transform: "translate(-15118.812 -1303.868)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M4673.531,3V0h-3V16.7a7.63,7.63,0,0,0,.612,3,7.768,7.768,0,0,0,2.389,3.088,7.655,7.655,0,0,0,4.7,1.611h1.3v-3h-1.3a4.713,4.713,0,0,1-4.7-4.7V9h6V6h-6V3Z",
    transform: "translate(-4649.128)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtevaLogo);
export default __webpack_public_path__ + "static/media/Eteva_Logo.e0088e53c26e1d659beb7a2e3c68998e.svg";
export { ForwardRef as ReactComponent };